module.exports = __webpack_public_path__ + "img/iconPromocao.a8b2fa1a.svg";